function locationAttributes(location) {
  return location && location.attributes ? location.attributes : {};
}

function normalizedAddress(location) {
  const address = locationAttributes(location).address;
  return typeof address === 'string' ? address.trim() : '';
}

function cityName(location) {
  const address = normalizedAddress(location);
  const commaIndex = address.indexOf(',');

  if (!address) {
    return '';
  }

  return (commaIndex >= 0 ? address.substr(0, commaIndex) : address).trim();
}

function cityNames(locations) {
  const names = (locations || []).map(cityName).filter(Boolean);
  return Array.from(new Set(names));
}

function locationsForCity(locations, city) {
  return (locations || []).filter((location) => cityName(location) === city);
}

function coordinateValue(value) {
  if (typeof value !== 'number' && typeof value !== 'string') {
    return null;
  }

  const normalizedValue = typeof value === 'string' ? value.trim() : value;
  if (normalizedValue === '') {
    return null;
  }

  const coordinate = Number(normalizedValue);
  return Number.isFinite(coordinate) ? coordinate : null;
}

function pickupLocationCoords(location) {
  const attributes = locationAttributes(location);
  const lat = coordinateValue(attributes.lat);
  const lng = coordinateValue(attributes.lng);

  return lat === null || lng === null ? null : [lat, lng];
}

function mapPickupLocations(locations) {
  return (locations || []).filter((location) => pickupLocationCoords(location) !== null);
}

module.exports = {
  cityName,
  cityNames,
  locationsForCity,
  mapPickupLocations,
  pickupLocationCoords,
};
